import CoinBR from '@/assets/images/CoinBR.png';
import CoinLb from '@/assets/images/CoinLb.png';
import Coinlt from '@/assets/images/coinlt.png';
import CoinRM from '@/assets/images/CoinRM.png';
import CoinTR from '@/assets/images/CoinTR.png';
import glowImg from '@/assets/images/Glow.png';
import { ALL_CONFIGS, BLACK_LIST_ADDRESS, MODE_COIN } from '@/config';
import { formatNumberKMB } from '@/utils/format';
import {
  ENDPOINTS,
  getCoinsInfo,
  getKoth,
  getMemeCoinsDetailByAddress,
  reduceString,
} from '@/utils/util';
import { useGetConfigState } from '@/zustand-store/config/selector';
import BigNumber from 'bignumber.js';
import { useEffect, useState } from 'react';
import { Link } from 'wouter';
import Lottie from 'lottie-react';
import CoinFalling from '@/assets/lotties/coinfalling.json';
import HowToLaunch from '../modals/HowToLaunch';
// import DisclaimerModal from '../modals/MemeDisclaimerModal';

const BannerMeme = () => {
  const [kothCoin, setKothCoin] = useState(null);
  const [showBadge, setShowBadge] = useState(true);
  // const curveLimit = useGetConfigState('CurveLimit');
  // const initBondingCurve = useGetConfigState('agentCurveInit');
  const ctoCurveLimit = useGetConfigState('memeCurveLimit');
  const ctoInitCurve = useGetConfigState('memeCurveInit');
  const degenInitCurve = useGetConfigState('DEGENCurveInit');
  const degenCurveLimit = useGetConfigState('DEGENCurveLimit');

  const [openModalHowToLaunch, setOpenModalHowToLaunch] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      // TODO: hardcode koth coin
      // const kingCoin = await getMemeCoinsDetailByAddress(
      //   'moonY5FtHgPRaYAUtxqaBgNM3TrTB1ubrCg7Sza2imG',
      // );
      const kingCoin = await getKoth(ENDPOINTS.BACKEND_MEME);

      if (kingCoin) {
        setKothCoin(kingCoin);
      } else {
        const { coins = [], isError } = await getCoinsInfo(
          ENDPOINTS.BACKEND_MEME,
          {
            limit: 1,
            nextKey: '',
            keyword: '',
            listed: 'live',
            sortBy: 'date',
          },
        );

        setKothCoin(coins?.[0]);
        // setKothCoin(data);
        setShowBadge(false);
      }
    };
    fetchData();
  }, []);

  const curveLimit =
    kothCoin?.metadata?.mode === MODE_COIN.CTO
      ? ctoCurveLimit
      : degenCurveLimit;
  const initBondingCurve =
    kothCoin?.metadata?.mode === MODE_COIN.CTO ? ctoInitCurve : degenInitCurve;

  const bondingCurveValue = new BigNumber(
    (kothCoin?.lamportReserves || 0).toString(),
  )
    .minus(initBondingCurve)
    .toNumber();

  const bondingCurvePercentOrg = new BigNumber(bondingCurveValue)
    .multipliedBy(100)
    .div(curveLimit);

  const bondingCurvePercent = bondingCurvePercentOrg.isGreaterThanOrEqualTo(100)
    ? 100
    : bondingCurvePercentOrg.toFixed(2, 1);

  const enableTokenAfterGolive =
    kothCoin?.date &&
    new Date(kothCoin.date).getTime() >
      ALL_CONFIGS.OFFICIAL_TIME - ALL_CONFIGS.TIMER.DAY_TO_SECONDS;

  const isListedOnRay = !!kothCoin?.raydiumPoolAddr;
  const isListedOnOraiDex = !!kothCoin?.oraidexPoolAddr;
  const isListed = isListedOnOraiDex || isListedOnRay;

  return (
    <>
      {/* <DisclaimerModal /> */}
      {openModalHowToLaunch && (
        <HowToLaunch onClose={() => setOpenModalHowToLaunch(false)} />
      )}
      <div className="md:px-0 px-5 font-meme relative w-full h-[510px] bg-banner-meme flex flex-col items-center justify-center">
        <div className="md:block hidden absolute top-0 m-auto w-full max-w-[1000px] h-full max-h-[350px]">
          <Lottie
            animationData={CoinFalling}
            autoPlay={!!kothCoin}
            loop={true}
          />
        </div>
        <div
          data-aos="flip-down"
          className="text-[50px] md:mt-0 mt-20 md:text-[120px] font-semibold text-[#FCFCFC] z-10 text-center"
          style={{ textShadow: '0px 14px 0px #37343E' }}
        >
          {/* Where <span className="text-[#A382FF]">M3m3</span> Launch */}
          <span className="text-[#A382FF]">M3M3</span> Degen Mode
        </div>
        <div
          className="text-[#FCFCFC] text-[16px] md:text-[24px] font-semibold z-10 text-center"
          data-aos="fade-up"
        >
          {/* A launch meme brought to you by @agents(dot)land */}
          Brought to you by Degenerator Project
        </div>
        <div
          onClick={() => setOpenModalHowToLaunch(true)}
          className="z-10 cursor-pointer mt-4 px-6 py-2 flex justify-between items-center bg-[#FCFCFC] font-bold rounded text-lg text-[#080A14]"
        >
          Launch Your Token ?
        </div>
        {kothCoin &&
          enableTokenAfterGolive &&
          !BLACK_LIST_ADDRESS.includes(kothCoin.token) && (
            <Link
              className="hover:scale-105 hover:brightness-125 z-10 md:animate-shake animate-infinite mt-20 ease-in transition-all relative bg-[#FFD400] min-w-[310px] max-w-[389px] cursor-pointer"
              style={{
                boxShadow: '-8px 8px 0px 0px #AA8E08, -8px 8px 0px 0px #212228',
              }}
              href={`/trading-meme/${kothCoin.token}`}
            >
              {showBadge && (
                <div className="absolute top-0 right-[6px] -translate-y-1/2 translate-x-1/2 rotate-[30deg]">
                  <div className="relative flex justify-center items-center animate-wiggle-more animate-infinite animate-duration-500">
                    <div className="absolute">
                      <KothBadge />
                    </div>
                    <div className="text-[#080A14] text-[18px] md:text-[20px] font-bold z-10 text-center">
                      <p>The One</p>
                      <p className="-mt-[2px]">Above All</p>
                    </div>
                  </div>
                </div>
              )}

              <div className="px-6 py-4">
                <div className="rounded-xl flex items-start gap-3 ">
                  <div className="">
                    <img
                      src={kothCoin.url}
                      alt="richolman"
                      className="rounded-[2px] w-[96px] h-[96px] object-cover"
                    />
                  </div>
                  <div className="flex flex-col text-[#080A14]">
                    <div className="text-[rgba(8,10,20,0.50)] text-[12px] md:text-[14px] font-medium">
                      Created by&nbsp;
                      <Link
                        href={`/profile/${kothCoin.creator?.wallet}`}
                        className="text-[#080A14] font-semibold hover:underline"
                      >
                        {reduceString(kothCoin.creator?.wallet || '', 4, 4)}
                      </Link>
                    </div>
                    <div className="text-[20px] leading-[20px] font-bold mt-2">
                      {kothCoin.name} (${kothCoin.ticker})
                    </div>
                    {isListed && (
                      <div className="text-[16px] font-semibold mt-4">
                        Listed on: {!!isListedOnRay && 'Raydium, '}
                        {!!isListedOnOraiDex && 'Oraidex'}
                      </div>
                    )}
                  </div>
                </div>
                <div className="line-clamp-3 font-medium text-[rgba(8,10,20,0.50)] text-[14px] my-4">
                  {kothCoin.description || ''}
                </div>
                <div className="text-[#080A14] text-[16px] font-semibold">
                  Marketcap&nbsp;&nbsp;
                  <span className="text-[#080A14]">
                    {formatNumberKMB(Number(kothCoin.marketcap || 0))}(
                    {isListed ? 100 : bondingCurvePercent}%)
                  </span>
                </div>
              </div>
            </Link>
          )}
        <img
          data-aos="fade-right"
          src={Coinlt}
          className="absolute md:block hidden left-0 top-[30%] -translate-y-1/2 -translate-x-1/4 -ml-[50px]"
        />
        <img
          data-aos="fade-right"
          src={CoinLb}
          className="absolute md:block hidden left-[150px] top-[70%]"
        />
        <img
          src={glowImg}
          className="absolute md:scale-100 scale-[2.5] left-[50%] top-[75%] md:top-full -translate-x-1/2 -translate-y-3/4"
        />
        <img
          data-aos="fade-left"
          src={CoinTR}
          className="absolute md:block hidden right-[50px] -top-[30px] -translate-y-1/4"
        />
        <img
          data-aos="fade-left"
          src={CoinRM}
          className="absolute md:block hidden right-[150px] top-[40%]"
        />
        <img
          data-aos="fade-left"
          src={CoinBR}
          className="absolute md:block hidden right-[300px] top-[75%]"
        />
      </div>
    </>
  );
};

export default BannerMeme;

export const KothBadge = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="151"
      height="141"
      viewBox="0 0 151 141"
      fill="none"
    >
      <path
        d="M38.0247 85.1031C33.8136 74.5732 25.1316 65.8783 12.9252 61.1426C25.9768 60.1139 36.7889 54.2853 43.8431 45.435C50.8783 36.6086 54.0939 24.8789 52.1462 12.1434C59.5637 22.8404 70.0685 29.2357 81.3505 30.8907C92.7008 32.5558 104.715 29.4052 115.012 21.1921C109.374 32.9594 109.052 45.2048 113.289 55.7267C117.506 66.2 126.189 74.8374 138.385 79.5523C125.342 80.5874 114.537 86.4208 107.483 95.2925C100.42 104.176 97.2012 116 99.1791 128.864C91.7598 118.139 81.2407 111.727 69.9423 110.07C58.59 108.405 46.5739 111.557 36.2756 119.773C41.9235 107.98 42.254 95.6786 38.0247 85.1031Z"
        fill="#A382FF"
        stroke="black"
        strokeWidth="2.74852"
      />
    </svg>
  );
};
